import {
  ACCOUNT_CHECK,
  CHECK_SERVICEABILITY,
  VERIFY_ADDRESS_SERVICEABILITY,
  INITIAL_ORDER_CREATE,
  RESET_STATE,
  RESET_SUBMIT_RESPONSE,
  SAVE_BUSINESS_INFO,
  SAVE_CHALLENGE_QUESTION_INFO,
  SAVE_PASSWORD,
  SAVE_PAYMENT_INFO,
  SAVE_PLAN_INFO,
  CLEAR_NORMALIZED_ADDRESS,
  SAVE_VAS_PLAN_INFO,
  SERVICE_CHECK,
  SERVICE_CHECK_FULFILLED,
  SESSION_CALL,
  SUBMIT_ORDER,
  UPDATE_CARD_ERROR,
  UPDATE_CUST_TC,
  UPDATE_ERROR_MSG,
  UPDATE_IS_BUSINESS_ADDRESS,
  UPDATE_ORDER,
  UPDATE_TOKENS,
  SET_TFN,
  SET_EXPRESS_LOADING,
  EXPRESS_VAS,
  SAVE_BUYFLOW,
  SAVE_WIRELESS_PLAN_INFO,
  CHECK_MOBILE_PRODUCTS,
  CHECK_DEVICE_COMPATIBILITY,
  SAVE_CHECKOUT_INFO,
  SCHEDULE_APPT_CHECK,
  SAVE_SCHEDULE_DATE_TIME,
  SAVE_RAW_SCHEDULE_DATE_TIME,
  GET_SERVICE_PROPS_BY_CODE,
  SET_ELNK_MAILBOX_REQ,
  SET_MAILBOX_REQ,
  GET_ACC_DOMAINS,
  VALIDATE_CARD,
  VALIDATE_BANK_DRAFT,
  SET_MOBILE_CONTAINER,
  SAVE_STEP_ONE,
  MOBILE_PRODUCTS,

  SAVE_SPANISH_LANGUAGE_PREFERENCE,
  GET_BUNDLES_DETAILS,
  SET_BUNDLE_PRODUCT,
  SAVE_MOBILEPROVIDER,
  SAVE_PHONENUMBER,
  SET_CUSTOM_TFN,
  SET_CUSTOM_WHI_TFN,
  SET_REFERRER,
  SET_RTS_VISIBLE,
  SET_RTS_ATTEMPT_COUNT,
  SET_ACTIVE_PRODUCT_TAB,
  SET_SELECTED_PRODUCT,
  SET_INVOCA_TFN,
  CLEAR_INVOCA_TFN,
  SET_INSTALL_TYPE,
  SEND_BROADBAND,
  GET_BROADBAND_DATA,
  SET_SITE_TOKEN,
  REDEEM_SITE_TOKEN,
  SET_REDEEM_TOKEN_STATUS
} from './Types';
import axios from 'axios';
import { api } from '../../util/axios'
import { getConfigs } from '../../config';

const config = getConfigs();

export const sessionCall = (landingPageUid) => {
  const data = {
    landingPageUid,
  }
  const request = api.axios({
    method: 'POST',
    url: `${config.API_ENDPOINT}/sessions/landing-pages`,
    data,
  })
  return {
    type: SESSION_CALL,
    payload: request
  }
}

export const getExpressVasProducts = (promoCode) => {
  const request = api.axios({
    method: 'GET',
    url: `${config.EXPRESS_VAS}/vas-products/${promoCode}/${config.BUSINESS_PARTNER}`,
  });
  return {
    type: EXPRESS_VAS,
    payload: request
  }
}

export const initialOrderCreate = orderDetails => {
  const request = api.axios({
    method: 'POST',
    url: `${config.API_ENDPOINT}/initial-order-create`,
    data: orderDetails,
  })
  return {
    type: INITIAL_ORDER_CREATE,
    payload: request
  }
}

export const updateOrder = (details, orderAccessToken) => {
  const request = api.axios({
    method: 'PUT',
    url: `${config.API_ENDPOINT}/order/${orderAccessToken}`,
    data: details
  })
  return {
    type: UPDATE_ORDER,
    payload: request
  }
}

export const validateCreditCard = (validateCardModel) => {
  const response = api.axios({
    method: 'POST',
    url: `${config.API_ENDPOINT}/cc-validate`,
    data: validateCardModel
  })
  return {
    type: VALIDATE_CARD,
    payload: response
  }
}

export const validateBankDraft = (bankBody) => {
  const response = api.axios({
    method: 'POST',
    url: `${config.API_ENDPOINT}/cc-validate`,
    data: bankBody
  })
  return {
    type: VALIDATE_BANK_DRAFT,
    payload: response
  }
}

export const clearNormalizedAddress = () => ({
  type: CLEAR_NORMALIZED_ADDRESS,
})

export const saveInternetPlan = planDetails => {
  return {
    type: SAVE_PLAN_INFO,
    payload: planDetails
  }
}

export const getBundleDetails = servCodes => {
  const request = api.axios({
    method: 'GET',
    url: `${config.API_ENDPOINT}/bundles/?bundlecodes=${servCodes}`,
  })
  return {
    type: GET_BUNDLES_DETAILS,
    payload: request
  }
}

export const saveVasPlanInfo = planDetails => {
  return {
    type: SAVE_VAS_PLAN_INFO,
    payload: planDetails
  }
}

export const resetState = () => {
  return {
    type: RESET_STATE
  }
}

export const resetSubmitResponse = () => {
  return {
    type: RESET_SUBMIT_RESPONSE,
  }
}


export const checkServiceability = (checkServiceabilityModel) => {
  const request = api.axios({
    method: 'POST',
    url: `${config.CHECK_SERVICEABILITY}/prequal`,
    data: checkServiceabilityModel
  });
  return {
    type: CHECK_SERVICEABILITY,
    payload: request
  }
}

export const validateAddressServiceability = (checkServiceabilityAddress) => {
  const request = api.axios({
    method: 'POST',
    url: `${config.CHECK_SERVICEABILITY}/validate-address`,
    data: checkServiceabilityAddress
  });
  return {
    type: VERIFY_ADDRESS_SERVICEABILITY,
    payload: request
  }
}


export const updateTokens = (tokens) => {
  return {
    type: UPDATE_TOKENS,
    tokens
  }
}

export const serviceCheck = (serviceCheckModel) => {
  const request = api.axios({
    method: 'POST',
    url: `${config.API_ENDPOINT}/service-check`,
    data: serviceCheckModel
  });
  return {
    type: SERVICE_CHECK,
    payload: request
  }
}

export const saveServiceCheckId = id => {
  return {
    type: SERVICE_CHECK_FULFILLED,
    payload: id
  }
}

export const checkMobileProducts = () => {
  const request = api.axios({
    method: 'GET',
    url: `${config.CHECK_SERVICEABILITY}/mobile-products/07712/elnkac`,
  });
  return {
    type: CHECK_MOBILE_PRODUCTS,
    payload: request
  }
}

export const checkDeviceCompatibility = (deviceCheckModel) => {
  const request = api.axios({
    method: 'POST',
    url: `${config.CHECK_SERVICEABILITY}/device-compatibility`,
    data: deviceCheckModel
  });
  return {
    type: CHECK_DEVICE_COMPATIBILITY,
    payload: request
  }
}

export const accountCheck = (accountCheckModel) => {
  const request = api.axios({
    method: 'POST',
    url: `${config.API_ENDPOINT}/account-check`,
    timeout: 1000 * 5,
    data: accountCheckModel,
  });
  return {
    type: ACCOUNT_CHECK,
    payload: request
  }
}

export const CheckScheduleAppt = (scheduleAppt) => {
  const request = api.axios({
    method: 'POST',
    url: `${config.CHECK_SERVICEABILITY}/install-status`,
    data: scheduleAppt
  });
  return {
    type: SCHEDULE_APPT_CHECK,
    payload: request
  }
}

export const saveScheduleDateTime = (dateTime) => {
  return {
    type: SAVE_SCHEDULE_DATE_TIME,
    payload: dateTime
  }
}

export const saveRawScheduleDateTime = (rawDateTime) => {
  return {
    type: SAVE_RAW_SCHEDULE_DATE_TIME,
    payload: rawDateTime
  }
}

export const updateIsBusinessAddress = isBusinessAddress => {
  return {
    type: UPDATE_IS_BUSINESS_ADDRESS,
    payload: isBusinessAddress
  }
}

export const saveBusinessInfo = businessInfoModel => {
  return {
    type: SAVE_BUSINESS_INFO,
    payload: businessInfoModel
  }
}

export const saveChgQuestionInfo = chgQuestionModel => {
  return {
    type: SAVE_CHALLENGE_QUESTION_INFO,
    payload: chgQuestionModel
  }
}

export const savePaymentInfo = paymentDetails => {
  return {
    type: SAVE_PAYMENT_INFO,
    payload: paymentDetails
  }
}

export const saveBuyflow = buyflow => {
  return {
    type: SAVE_BUYFLOW,
    payload: buyflow
  }
}

export const saveWirelessPlanInfo = planDetails => {
  return {
    type: SAVE_WIRELESS_PLAN_INFO,
    payload: planDetails
  }
}

export const saveCheckoutInfo = Details => {
  return {
    type: SAVE_CHECKOUT_INFO,
    payload: Details
  }
}

export const updateCustTC = custDetail => {
  return {
    type: UPDATE_CUST_TC,
    payload: custDetail
  }
}

export const updateErrorMsg = message => {
  return {
    type: UPDATE_ERROR_MSG,
    payload: message
  }
}

export const updateCardErrorModal = message => {
  return {
    type: UPDATE_CARD_ERROR,
    payload: message
  }
}

export const setExpressLoading = value => {
  return {
    type: SET_EXPRESS_LOADING,
    payload: value
  }
}

export const savePassword = password => {
  return {
    type: SAVE_PASSWORD,
    payload: password
  }
}
export const submitOrder = (submitOrderModel) => {
  const response = api.axios({
    method: 'POST',
    url: submitOrderModel.isExpressContainer ? `${config.API_ENDPOINT}/order-submission-vas` : `${config.API_ENDPOINT}/order-submission`,
    data: submitOrderModel
  })
  return {
    type: SUBMIT_ORDER,
    payload: response
  }
}

export const setTFN = nbc => {
  return {
    type: SET_TFN,
    payload: nbc
  }
}

export const setInvocaTfn = (tfn) => ({
  type: SET_INVOCA_TFN,
  payload: tfn,
});

export const clearInvocaTfn = () => ({
  type: CLEAR_INVOCA_TFN,
});

export const getServicePropsByCode = (servCode) => {
  const request = api.axios({
    method: 'GET',
    url: `${config.API_ENDPOINT}/services/${servCode}`,
  });
  return {
    type: GET_SERVICE_PROPS_BY_CODE,
    payload: request,
  }
}

export const setElnkMailboxReq = (value) => {
  return {
    type: SET_ELNK_MAILBOX_REQ,
    payload: value,
  }
}

export const setMBoxReqObj = (value) => {
  return {
    type: SET_MAILBOX_REQ,
    payload: value,
  }
}

export const getAccountDomains = () => {
  const request = api.axios({
    method: 'GET',
    url: `${config.API_ENDPOINT}/accounts/domains`,
  });
  return {
    type: GET_ACC_DOMAINS,
    payload: request,
  }
}

export const setMobileOnlyContainer = (value) => {
  return {
    type: SET_MOBILE_CONTAINER,
    payload: value,
  }
}

export const saveFirstStep = value => {
  return {
    type: SAVE_STEP_ONE,
    payload: value,
  }
}

export const getMobileProducts = (promoCode) => {
  const request = api.axios({
    method: 'GET',
    url: `${config.CHECK_SERVICEABILITY}/mobile-products/${promoCode}/${config.BUSINESS_PARTNER}`,
  });
  return {
    type: MOBILE_PRODUCTS,
    payload: request
  }
}

export const saveSpanishLanguagePreference = value => {
  return {
    type: SAVE_SPANISH_LANGUAGE_PREFERENCE,
    payload: value
  }
}

export const setSelectedBundle = (data) => ({
  type: SET_BUNDLE_PRODUCT,
  payload: data,
});
export const savePhoneNumber = (phone) => {
  const data = {
    phoneNumber: phone,
    appClient: 'www',
    appClientData: {
      app: 'www',
      name: 'checkout',
    }
  }
  const request = api.axios({
    method: 'POST',
    url: `${config.API_ENDPOINT}/getall`,
    data,
  });
  return {
    type: SAVE_PHONENUMBER,
    payload: request
  }
}

export const saveMobileProvider = (provider) =>{
  return{
    type: SAVE_MOBILEPROVIDER,
    payload: provider
  }
}

export const setCustomTFN = tfn => {
  return {
    type: SET_CUSTOM_TFN,
    payload: tfn
  }
}

export const setCustomWhiTFN = tfn => {
  return {
    type: SET_CUSTOM_WHI_TFN,
    payload: tfn
  }
}

export const setReferrer = tfn => {
  return {
    type: SET_REFERRER,
    payload: tfn
  }
}

export const setRtsVisible = (data) => ({
  type: SET_RTS_VISIBLE,
  payload: data,
})

export const setRtsAttemptCount = (data) => ({
  type: SET_RTS_ATTEMPT_COUNT,
  payload: data,
})

export const setActiveProductTab = (data) => ({
  type: SET_ACTIVE_PRODUCT_TAB,
  payload: data,
})

export const setSelectedProduct = (data) => (
  {
    type: SET_SELECTED_PRODUCT,
    payload: data,
  })

export const setInstallType = (data) => ({
  type: SET_INSTALL_TYPE,
  payload: data,
})

export const sendBroadbandEmail = (details,promoCode,partnerId,serviceRef) => {
  const request = api.axios({
    method: 'PUT',
    url: `${config.API_ENDPOINT}/email/broadband/labels/${promoCode}/${partnerId}/${serviceRef}`,
    data: details
  });
  return {
    type: SEND_BROADBAND,
    payload: request,
  };
};

export const getBroadbandData = (bbLabelParams) => {
  const { promoCode, servRef: bbLabelServRef, isDynmaic, partnerId: partner } = bbLabelParams;

  const request = api.axios({
    method: 'GET',
    url: `${config.CHECK_SERVICEABILITY}/current-product-list/${promoCode}/${partner}/${bbLabelServRef}/broadband/label?isDynamic=${isDynmaic}`,
  });

  return {
    type: GET_BROADBAND_DATA,
    payload: request,
  };
};

// The allowlist is the whole of the resolution: a referrer either matches an entry and the
// token goes to that entry's hardcoded HTTPS origin, or the redemption is refused. There is
// no configured fallback, so there is no environment in which an unrecognised referrer still
// reaches a WordPress host.
//
// Map rather than an object literal: an object's inherited keys are truthy lookups, so
// ?referrer=constructor resolved to Object's source text and ?referrer=__proto__ to
// '[object Object]', producing a relative URL that POSTed a live token to our own origin
// instead of taking the fail-closed branch.
//
// No localhost entry. It shipped in the production bundle, where ?referrer=localhost made a
// production checkout POST the customer's single-use token over plaintext HTTP to a listener
// on the customer's own machine. Local development points at one of the hosts below.
//
// One entry, because there is one host. DNS for halo.earthlink.net is live and WordPress
// serves it canonically: the landing page emits referrer=halo.earthlink.net, and the WP Engine
// hostname it was built on now 301s here. That hostname is deliberately NOT an allowlist key -
// a referrer this app does not recognise is refused outright rather than redeemed against a
// host that redirects, and a cross-origin 301 on the POST carrying the single-use token is not
// a path this flow can survive.
//
// Values carry no trailing slash: callers append '/wp-json/...' directly.
const TRUSTED_REFERRER_BASE_URLS = new Map([
  ['halo.earthlink.net', 'https://halo.earthlink.net'],
]);

export const setSiteToken = (token) => ({
  type: SET_SITE_TOKEN,
  payload: token,
});

export const setRedeemTokenStatus = (isValid, isFFReferrer) => ({
  type: SET_REDEEM_TOKEN_STATUS,
  payload: { isValid, isFFReferrer },
});

// Fail-closed, with no exceptions: the caller's value selects an entry, it never builds the
// URL. An unrecognised or absent referrer refuses the redemption outright.
export const resolveRedeemBaseUrl = (referrerHost = '') => {
  if (!referrerHost) {
    return '';
  }
  const cleanHost = String(referrerHost).replace(/^https?:\/\//, '').split(/[/?#]/)[0].toLowerCase();
  return TRUSTED_REFERRER_BASE_URLS.get(cleanHost) || '';
};

export const redeemSiteToken = (siteToken, referrerHost = '') => {
  const cleanWpBaseUrl = resolveRedeemBaseUrl(referrerHost);
  if (!cleanWpBaseUrl) {
    return {
      type: REDEEM_SITE_TOKEN,
      payload: Promise.reject(new Error('Site token redemption host is not configured')),
    };
  }
  const url = `${cleanWpBaseUrl}/wp-json/elnk-core/v1/site-tokens/redeem`;

  const request = axios.post(url, { site_token: siteToken }, {
    headers: {
      'Content-Type': 'application/json',
    },
    // The whole page is held behind a loader until this settles, so an unreachable WordPress
    // host must fail fast rather than park the customer on a spinner for the OS TCP timeout.
    // The rejection path degrades to standard checkout, which is the right outcome here.
    timeout: 1000 * 5,
  });

  return {
    type: REDEEM_SITE_TOKEN,
    payload: request,
  };
};

/**
 * Tracking-only order write (ELNKWEB-3215).
 *
 * Deliberately NOT a redux action. `updateOrder` runs through
 * redux-promise-middleware, which emits UPDATE_ORDER_PENDING / _FULFILLED /
 * _REJECTED, and OrderReducer turns those into shared `loading`, `hasError` and
 * `orderInfo` state that foreground checkout UI renders: a rejected tracking
 * write would paint the "error processing your order" message on the review
 * page, a pending one blanks the header TFN (`shouldShowHeaderTfn` gates on
 * `!loading`) and disables Place Your Order, and a fulfilled one landing during
 * a genuine submit would clear that submit's error and re-enable the button.
 * Tracking must never touch checkout state, so this returns the bare promise and
 * no reducer ever sees it.
 */
export const putOrderTracking = (details, orderAccessToken) =>
  api.axios({
    method: 'PUT',
    url: `${config.API_ENDPOINT}/order/${orderAccessToken}`,
    data: details,
  });
